import styled from 'styled-components';
const TablePageStyled = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 0 8px;
  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    > div {
      margin-right: 15px;
    }
    span {
      // font-size: 16px;
      color: #fff;
    }
    img {
      width: 18px;
      height: 18px;
    }
  }
  :global {
    .ant-switch-checked {
      background-color: #ba5452;
    }
    .ant-switch-checked:focus {
      box-shadow: 0 0 0 2px rgb(185, 84, 82);
    }
  }
  .hover {
    cursor: pointer;
    position: relative;
    display: block;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    transform: scale(1, 1);
    transition: all 0.3s;
  }
  .hover:hover {
    transform: scale(1.1, 1.1);
    transition: all 0.3s;
    cursor: pointer;
  }
`;
export default TablePageStyled;
